import {
    AdditionalFeesAllowed, ContractCurrency,
    FeeChargeability,
    ProductType,
} from 'app/enums/label.enums'
import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'
import {
    StandardAdditionalFeesFilterRequestResponse,
} from 'app/requests/APricingRateCard/APricingRateCard.types'

const columns: SkyDataGridColumnDefinition<
    StandardAdditionalFeesFilterRequestResponse
>[] = [
    {
        name: 'feeName',
        componentName: 'EnumValue',
        allowedValuesEnum: AdditionalFeesAllowed,
        labelKey: 'ADDITIONAL_FEE',
    },
    {
        name: 'feeChargability',
        componentName: 'EnumValue',
        allowedValuesEnum: FeeChargeability,
        labelKey: 'CHARGEABILITY',
    },
    {
        name: 'productType',
        componentName: 'EnumValue',
        allowedValuesEnum: ProductType,
        labelKey: 'PRODUCT_TYPE',
    },
    {
        name: 'description',
        labelKey: 'A_QUOTE_DESCRIPTION',
    },
    {
        name: 'currency',
        componentName: 'EnumValue',
        allowedValuesEnum: ContractCurrency,
        labelKey: 'CURRENCY',
        maxWidth: 100,
    },
    {
        name: 'feeValue',
        labelKey: 'AMOUNT',
    },
]

export default columns
